import React, { ChangeEvent, useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  FormControl,
  Grid,
  IconButton,
  Input,
  MenuItem,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Tabs,
  Tab,
  FormControlLabel,
  RadioGroup,
  Radio,
  InputAdornment,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { Autocomplete } from "@react-google-maps/api";
import * as Yup from "yup";
import { useFormik } from "formik";
import { isNumber } from "../../utils/validation";
import {
  useAddTutorInfoMutation,
  useLazyGetutorByIdQuery,
  usePutTutorProfileMutation,
} from "../../services/tutor";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import {
  STORAGE_KEYS,
  errorToast,
  setToStorage,
  successToast,
  warnToast,
} from "../../helpers";
import { UploadMedia } from "../../utils/uploadMedia";
import Loader from "../../helpers/Loader";
import CloseIcon from '@mui/icons-material/Close';


const ProfileSetup = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [image, setImage] = useState<string>("");
  const { _id } = useParams();
  const [dialCode, setPhoneCode] = useState("+1");

  const [profile_picture, setProfilePicture] = useState<any>("");
  const [ByIdDetails, setByIdDetails] = useState<any>([]);
  const [autocomplete, setAutocomplete] = useState<any>();
  const [imageId, setImageId] = useState(null);
  const [addTutorInfo, { isLoading }] = useAddTutorInfoMutation();
  const [updateTutor] = usePutTutorProfileMutation();
  const [getTutorById] = useLazyGetutorByIdQuery();


  const onLoad = (autocompleteObj: any) => {
    setAutocomplete(autocompleteObj);
  };
  const onPlaceChanged = async () => {
    if (autocomplete) {
      let place = await (autocomplete as any).getPlace();

      if (place && place.address_components) {
        let address = place.address_components;

        let state,
          city,
          country,
          zip = "";

        address.forEach(function (component: any) {
          let types = component.types;

          if (
            types.indexOf("locality") > -1 ||
            types.indexOf("administrative_area_level_3") > -1
          ) {
            city = component.long_name;
          }
          if (types.indexOf("postal_code") > -1) {
            zip = component.long_name;
          }
          if (types.indexOf("administrative_area_level_1") > -1) {
            state = component?.long_name || "";
          }
          if (types.indexOf("country") > -1) {
            country = component?.long_name || "";
          }
        });
        var lat = place.geometry.location.lat();
        var lng = place.geometry.location.lng();
        formik.setFieldValue("address", place?.formatted_address);
        formik.setFieldValue("latitude", lat || "");
        formik.setFieldValue("longitude", lng || "");
      }
    }
  };

  const fetchDataById = async (_id: any) => {
    try {
      const response = await getTutorById({ userId: _id }).unwrap();
      console.log("9090", response);
      if (response.statusCode === 200) {
        setByIdDetails(response?.data);
        setSelectedGender(response?.data?.gender);

        setPhoneCode(ByIdDetails?.dialCode ? ByIdDetails?.dialCode : dialCode);
        formik.setFieldValue("dialCode", response?.data?.dialCode);
        formik.setFieldValue("profile_picture", response?.data?.image);
        formik.setFieldValue("email", response?.data?.email);
        formik.setFieldValue("userName", response?.data?.userName);
        formik.setFieldValue("phoneNo", response?.data?.phoneNo);
        formik.setFieldValue("gender", response?.data?.gender);
        formik.setFieldValue("age", formatDate(response?.data?.age));
        formik.setFieldValue("shortBio", response?.data?.shortBio);
        formik.setFieldValue("name", response?.data?.name);
        formik.setFieldValue("address", response?.data?.address);
        formik.setFieldValue("latitude", response?.data?.latitude || 0);
        formik.setFieldValue("longitude", response?.data?.longitude || 0);
        formik.setFieldValue(
          "startDate",
          response?.data?.teachingDetails?.startDate
        );
        formik.setFieldValue(
          "endDate",
          response?.data?.teachingDetails?.endDate
        );
        formik.setFieldValue(
          "totalTeachingExperience",
          response?.data?.teachingdetails?.totalTeachingExperience
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (_id) {
      fetchDataById(_id);
    }
  }, [_id]);
  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    try {
      if (!file) {
        formik.setFieldValue("profile_picture", "");
        setProfilePicture("");
        setImageId(null);
        return;
      }

      const res = await UploadMedia(file);
      if (res?.statusCode === 200) {
        formik.setFieldValue("profile_picture", res?.data?.image);
        setProfilePicture(res?.data?.image);
      } else {
        errorToast(res?.message);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      errorToast("Error uploading image. Please try again.");
    }
  };

  // for the idProof
  //   const handleIdProof = () => {
  //   const newFields: IdProof[] = [...idProofImage, {idProof: ""}];
  //   setidProofImage(newFields);
  // }

  const [selectedGender, setSelectedGender] = useState("");
  const [error, setError] = useState(false);




  const handleGenderChange = (event: any) => {
    setSelectedGender(event.target.value);
  };

  const formatDate = (isoString: string) => {
    if (!isoString) return "";
    return isoString.split("T")[0];
  };

  console.log("idgwd", ByIdDetails?.age);
  const formik = useFormik({
    // enableReinitialize: true,
    initialValues: {
      image: ByIdDetails?.image || profile_picture,
      name: ByIdDetails?.name || "",
      userName: ByIdDetails?.userName || "",
      email: ByIdDetails?.email || "",
      phoneNo: ByIdDetails?.phoneNo || "",
      age: formatDate(ByIdDetails?.age) || "",
      totalTeachingExperience: ByIdDetails?.totalTeachingExperience || "",
      educationLevel: ByIdDetails?.educationLevel || "",
      teachingOption: ByIdDetails?.teachingOption || "",
      dialCode: ByIdDetails?.dialCode ? ByIdDetails?.dialCode : dialCode,
      gender: ByIdDetails?.gender || selectedGender,
      startTime: ByIdDetails?.startTime || "",
      endTime: ByIdDetails?.endTime || "",
      shortBio: ByIdDetails?.shortBio || "",
      address: ByIdDetails?.address || "",
      latitude: ByIdDetails?.latitude || 0,
      longitude: ByIdDetails?.longitude || 0,
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required("Full Name is required"),
      address: Yup.string().required("Address is required"),
      email: Yup.string()
        .email("Enter a valid email address")
        .required("Email is required"),
      userName: Yup.string().required("User name is required"),
      phoneNo: Yup.string().required("Phone Number is required"),
      age: Yup.string().required("This field is required"),
      gender: Yup.string().required("Gender is required"),
      shortBio: Yup.string().required("Short Bio is required"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        if (!formik.isValid) return;
        if (formik.values.latitude === 0 && formik.values.longitude === 0) {
          warnToast("Please select a valid address");
          return;
        }

        setSubmitting(true);

        console.log("Tutor Values:", values);

        const body = {
          email: values.email || "",
          name: values.name || "",
          dialCode: dialCode,
          phoneNo: values.phoneNo || "",
          image: profile_picture,
          age: String(values.age) || "",
          userName: values.userName,
          gender: selectedGender,
          shortBio: values.shortBio || "",
          address: values.address || "",
          latitude: values.latitude || 0,
          longitude: values.longitude || 0,
        };

        const body2 = {
          ids: _id ? [_id] : [],
          status: "tutorUpdate",
          email: values.email || "",
          name: values.name || "",
          dialCode: dialCode,
          phoneNo: values.phoneNo || "",
          image: profile_picture,
          age: String(values.age) || "",
          userName: values.userName,
          gender: selectedGender,
          shortBio: values.shortBio || "",
          address: values.address || "",
          latitude: values.latitude || 0,
          longitude: values.longitude || 0,
        };
        console.log("body", body2);
        if (!_id) {
          try {
            const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
            const response: any = await addTutorInfo(encryptedBody).unwrap();
            if (response?.statusCode === 200) {
              successToast("Tutor added successfully");
              localStorage.setItem("tutorId", response?.data?._id);
              setToStorage(STORAGE_KEYS.tutorId, response?.data?._id);
            }
          } catch (error: any) {
            console.error("Error adding tutor:", error);
            if (error?.response?.data?.message) {
              errorToast(error?.response?.data?.message);
            } else {
              errorToast(error?.data?.message || "");
            }
          }
        } else {
          try {
            console.log("---00000", body);
            const encryptedBody = generateEncryptedKeyBody(body2) as CommonBody;
            let response = await updateTutor({ encryptedBody }).unwrap();
            if (response?.statusCode === 200) {
              successToast("Tutor updated successfully");
            }
          } catch (e: any) {
            errorToast(e?.data?.message || "");
          }
        }
      } catch (error: any) {
        errorToast(error?.message);
      } finally {
        setSubmitting(false);
      }
    },
  });

  const handleClear = () => {
    formik.setFieldValue("latitude", 0);
    formik.setFieldValue("longitude", 0);
    formik.setFieldValue("address", "");
  };


  const handleChangePhone = (phone: any, country: any) => {
    formik.setFieldValue("phoneNo", phone?.replace(country?.dialCode, ""));
    setPhoneCode(
      country?.dialCode.includes("+") ? "" : "+" + country?.dialCode
    );
  };

  useEffect(() => {
    setPhoneCode(dialCode || "");
    setProfilePicture(image || "");
  }, []);




  useEffect(() => {
    formik.setFieldValue("image", profile_picture);
  }, [profile_picture]);
  return (
    <div className="main_loyout">
      <div className="dashboard">
        {_id ? (
          <h1 className="mn_hdng">Edit Tutor</h1>
        ) : (
          <h1 className="mn_hdng">Add Tutor</h1>
        )}
        <Loader isLoad={isLoading} />
        <Button
          className="btn btn_primary"
          onClick={() => {
            navigate("/manage-tutors");
          }}
        >
          Back
        </Button>
      </div>

      <Card className="cards">
        <form onSubmit={formik.handleSubmit}>
          <CardContent sx={{ p: 1 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography className="custom_label">Image</Typography>
                {formik.values.image ? (
                  <div className="upload_image_preview">
                    <CardMedia
                      component="img"
                      image={formik.values.image}
                      alt="photo"
                    />
                    <CancelIcon
                      onClick={(e) => {
                        e.preventDefault();
                        setProfilePicture("");
                        formik.setFieldValue("profile_picture", "");
                      }}
                    />
                  </div>
                ) : (
                  <Box className="upload_image">
                    <label htmlFor="icon-button-file">
                      <Input
                        sx={{ display: "none" }}
                        id="icon-button-file"
                        type="file"
                        inputProps={{
                          accept: "image/png,image/jpeg",
                        }}
                        onChange={handleImageUpload}
                      />
                      <Button component="span" className="upload_image_btn">
                        <img
                          src={
                            ByIdDetails?.image
                              ? ByIdDetails.image
                              : `/static/images/user_placeholder.png`
                          }
                          // src="/static/images/user_placeholder.png"
                          alt=""
                        />
                        <CameraAltIcon />
                      </Button>
                    </label>
                  </Box>
                )}
              </Grid>
              {/* <Grid item xs={3}>
              <Typography className="custom_label">
                Account Status : Pending
              </Typography>
            </Grid> */}
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Typography className="custom_label">Full Name</Typography>
                <TextField
                  className="text_field"
                  hiddenLabel
                  type={"text"}
                  name="name"
                  variant="outlined"
                  fullWidth
                  id="name"
                  placeholder="Full Name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                  helperText={
                    formik.touched.name && formik.errors.name
                      ? formik.errors.name.toString()
                      : ""
                  }
                />
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Typography className="custom_label">User Name</Typography>
                <TextField
                  className="text_field"
                  hiddenLabel
                  type={"text"}
                  name="userName"
                  variant="outlined"
                  fullWidth
                  id="uername"
                  placeholder="User Name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.userName}
                  helperText={
                    formik.touched.userName && formik.errors.userName
                      ? formik.errors.userName.toString()
                      : ""
                  }
                />
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Typography className="custom_label">Email</Typography>
                <TextField
                  hiddenLabel
                  type={"email"}
                  name="email"
                  variant="outlined"
                  fullWidth
                  placeholder="Email"
                  id="email"
                  className="text_field"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  helperText={
                    formik.touched.email && formik.errors.email
                      ? formik.errors.email.toString()
                      : ""
                  }
                />
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Typography className="custom_label">Phone Number</Typography>
                <PhoneInput
                  value={
                    (ByIdDetails?.dialCode ? ByIdDetails?.dialCode : dialCode) +
                    formik.values.phoneNo
                  }
                 
                  country={"us"}
                  placeholder="0 (000) 000-000"
                  enableSearch={true}
                  inputStyle={{ width: "100%" }}
                  onChange={(phone, country) =>
                    handleChangePhone(phone, country)
                  }
                  onBlur={formik.handleBlur}
                />
                {formik.touched.phoneNo && formik.errors.phoneNo ? (
                  <h6 className="err_msg">
                    {formik.touched.phoneNo && formik.errors.phoneNo.toString()}
                  </h6>
                ) : (
                  ""
                )}
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Typography className="custom_label">Date Of Birth</Typography>
                <TextField
                  hiddenLabel
                  type={"date"}
                  name="age"
                  variant="outlined"
                  fullWidth
                  placeholder="Date Of Birth"
                  // id="lastName"
                  className="text_field"
                  // onChange={formik.handleChange}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.age}
                  helperText={
                    formik.touched.age && formik.errors.age
                      ? formik.errors.age.toString()
                      : ""
                  }
                />
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Typography className="custom_label">Gender</Typography>
                <FormControl sx={{ width: "100%" }}>
                  <Select
                    className="select_div"
                    fullWidth
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={selectedGender}
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    displayEmpty
                    onChange={(event) => {
                      handleGenderChange(event);
                      formik.setFieldValue("gender", event.target.value);
                    }}
                  >
                    <MenuItem value="" disabled>
                      Select
                    </MenuItem>
                    <MenuItem value="MALE">Male</MenuItem>
                    <MenuItem value="FEMALE">Female</MenuItem>
                    {/* <MenuItem value="Other">Other</MenuItem> */}
                  </Select>
                </FormControl>
                {error && !selectedGender ? (
                  <div className="err_msg">Gender is required</div>
                ) : null}
              </Grid>


              <Grid item xs={4}>
                {/* <Typography className="custom_label">Address</Typography>
                <TextField
                  className="text_field"
                  hiddenLabel
                  type={"text"}
                  name="address"
                  variant="outlined"
                  fullWidth
                  placeholder="Address"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.address}
                  helperText={
                    formik.touched.address && formik.errors.address
                      ? formik.errors.address.toString()
                      : ""
                  }
                /> */}
                <Typography className="custom_label">Address</Typography>
                <Autocomplete
                  onLoad={onLoad}
                  onPlaceChanged={() => onPlaceChanged()}

                >
                  <TextField
                    className="text_field"
                    hiddenLabel
                    name="address"
                    value={formik.values?.address}
                    placeholder="Enter Address"
                    fullWidth
                    helperText={
                      formik.touched.address &&
                        typeof formik.errors.address === "string"
                        ? formik.errors.address
                        : undefined
                    }
                    onChange={(e) => {
                      if (
                        e.target.value.trim() === "" ||
                        e.target.value === "."
                      ) {
                        formik.setFieldValue("address", "");
                      } else {
                        formik.handleChange(e);
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                      }
                    }}
                    InputProps={{
                      endAdornment: formik.values.address ? (
                        <InputAdornment position="end">
                          <IconButton onClick={handleClear}>
                            <CloseIcon />
                          </IconButton>
                        </InputAdornment>
                      ) : null,
                    }}
                  />
                </Autocomplete>
              </Grid>

              <Grid item xs={4}>
                <Typography className="custom_label">Short Bio</Typography>
                <TextField
                  className="text_field"
                  hiddenLabel
                  type={"text"}
                  name="shortBio"
                  variant="outlined"
                  fullWidth
                  placeholder="Short Bio"
                  multiline
                  maxRows={4}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.shortBio}
                  helperText={
                    formik.touched.shortBio && formik.errors.shortBio
                      ? formik.errors.shortBio.toString()
                      : ""
                  }
                />
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12} />
              <Grid item lg={4} md={4} sm={6} xs={12} />
            </Grid>
            <div className="form_btn">
              <Button
                size="large"
                type="submit"
                className="btn btn_primary"
                onClick={() => setError(true)}
              >
                Submit
              </Button>
            </div>
          </CardContent>
        </form>
      </Card>
    </div>
  );
};

export default ProfileSetup;
